import React from 'react'
import styles from './SlideinItem.scss'

const SlideinItem = ({ onClick, img, text }) => {
  return (
    <div className="item" onClick={onClick}>
      <style jsx>{styles}</style>
      <i className="icon" style={{ backgroundImage: `url(${img})` }} />
      <div className="text">{text}</div>
    </div>
  )
}

export default SlideinItem
